import { render, staticRenderFns } from "./giftsList.vue?vue&type=template&id=041cae0a&scoped=true&"
import script from "./giftsList.vue?vue&type=script&lang=js&"
export * from "./giftsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041cae0a",
  null
  
)

export default component.exports